import type { InspectionViewContext } from './inspectionResultSchema'

const contexts = new Map<string, InspectionViewContext>()

export function inspectionViewScope(
  siteId: string,
  tabId: string | undefined
): string {
  return JSON.stringify([siteId, tabId ?? 'solo'])
}

export function writeInspectionViewContext(
  scope: string,
  context: InspectionViewContext | null
): void {
  if (context) contexts.set(scope, context)
  else contexts.delete(scope)
}

export function readInspectionViewContext(
  scope: string
): InspectionViewContext | undefined {
  return contexts.get(scope)
}
